import {gridColumnTypes} from "./columnTypes";
import {handleLayoutChangedEvent} from "./states/layout";
import {handleFilterChangedEvent} from "./states/filter";
import {booleanCellRenderer, booleanFilterCellRenderer, nullableBoolCellRenderer} from "./helpers/boolean";
import {iconCellRenderer} from "./columnTypes/iconCol";
import {htmlCellRenderer, linkCellRenderer} from "./columnTypes/baseTypes";
import {deleteCellRenderer} from "./columnTypes/deleteCol";
import {k1UserIdCellRenderer} from "./columnTypes/idK1UserCol";
import {onCellKeyDown} from "./events/key";
import {CountStatusBar} from "./components/countStatusBar";
import {getDatePicker} from "./components/datepicker";
import {EshopSwitcher} from "./components/eshopSwitcher";
import {getDefaultContextMenuForGrid} from "./contextMenu";
import {basicToolPanels} from "./panels";

export function getDefaultGridOptions() {
	return {
		components: {
			nullableBoolCellRenderer:nullableBoolCellRenderer,
			booleanCellRenderer: booleanCellRenderer,
			booleanFilterCellRenderer: booleanFilterCellRenderer,
			iconCellRenderer: iconCellRenderer,
			htmlCellRenderer: htmlCellRenderer,
			linkCellRenderer: linkCellRenderer,
			iconFilterCellRenderer: iconCellRenderer,
			deleteCellRenderer: deleteCellRenderer,
			k1UserIdCellRenderer: k1UserIdCellRenderer,
			agDateInput: datepickerComponent,
			datePicker: getDatePicker(),
			countStatusBarComponent: CountStatusBar,
			eshopSwitcherComponent: EshopSwitcher,
		},
		onSortChanged: handleLayoutChangedEvent,
		onColumnResized: handleLayoutChangedEvent,
		onColumnGroupOpened: handleLayoutChangedEvent,
		onColumnMoved: handleLayoutChangedEvent,
		onColumnPinned: handleLayoutChangedEvent,
		onColumnVisible: handleLayoutChangedEvent,
		onColumnPivotChanged: handleLayoutChangedEvent,
		onFilterChanged: handleFilterChangedEvent,
		onColumnRowGroupChanged: handleLayoutChangedEvent,
		onCellKeyDown: onCellKeyDown,
		onGridReady: function (params) {
		},
		context: {
			editing: false,
		},
		columnTypes: gridColumnTypes,
		accentedSort: true,
		rowSelection: 'multiple',
		suppressRowClickSelection: true,
		enableCellTextSelection: true,
		localeText: window.czechLocaleText,
		getContextMenuItems: getDefaultContextMenuForGrid,
		getRowId: params => params.data.id,
		sideBar: {
			toolPanels: basicToolPanels
		},
		statusBar: {
			statusPanels: [
				{
					statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left'
				},
				{
					statusPanel: 'agSelectedRowCountComponent', align: 'right'
				},
			]
		}
	};
}

window.basicToolPanels = basicToolPanels
